// Regular divergence is reported only after both pivot windows are complete.
// The forming last bar cannot confirm a pivot, so later ticks cannot retract it.
export function indicatorDivergences(outputs,candles,{left=5,right=5,minBars=5,maxBars=60,closedThrough=candles.at(-2)?.[0]??-Infinity}={}){
    left=Math.max(1,Math.floor(left));right=Math.max(1,Math.floor(right));
    const prices=new Map(candles.map(row=>[row[0],row])),events=[];
    let priorLow=null,priorHigh=null;
    for(let index=left;index+right<outputs.length;index++){
        const row=outputs[index],value=row[1],price=prices.get(row[0]),confirmation=outputs[index+right];
        if(!price||!Number.isFinite(value)||confirmation[0]>closedThrough)continue;
        const before=outputs.slice(index-left,index).map(row=>row[1]),after=outputs.slice(index+1,index+right+1).map(row=>row[1]);
        if(![...before,...after].every(Number.isFinite))continue;
        const pivotLow=before.every(other=>value<=other)&&after.every(other=>value<other);
        const pivotHigh=before.every(other=>value>=other)&&after.every(other=>value>other);
        for(const [pivot,kind,previous] of [[pivotLow,'bullish',priorLow],[pivotHigh,'bearish',priorHigh]]){
            if(!pivot)continue;
            const current={index,time:row[0],value,price:kind==='bullish'?price[3]:price[2]};
            if(previous&&index-previous.index>=minBars&&index-previous.index<=maxBars){
                const matches=kind==='bullish'?current.price<previous.price&&current.value>previous.value:current.price>previous.price&&current.value<previous.value;
                if(matches)events.push({kind,previous,current,confirmedAt:confirmation[0]});
            }
            if(kind==='bullish')priorLow=current;else priorHigh=current;
        }
    }
    return events;
}
export function drawIndicatorDivergences(ctx,outputs,candles,layout,settings){
    if(!settings.calculateDivergence)return;
    const events=indicatorDivergences(outputs,candles,{left:settings.divergenceLeft,right:settings.divergenceRight,minBars:settings.divergenceMinBars,maxBars:settings.divergenceMaxBars});
    ctx.save();ctx.lineWidth=2;ctx.setLineDash([]);ctx.font='11px sans-serif';
    for(const event of events){
        if(settings[event.kind==='bullish'?'showBullDivergence':'showBearDivergence']===false)continue;
        ctx.strokeStyle=ctx.fillStyle=event.kind==='bullish'?(settings.bullDivergenceColor||'#26a69a'):(settings.bearDivergenceColor||'#ef5350');
        const x=layout.t2screen(event.current.time),y=layout.$2screen(event.current.value);
        ctx.beginPath();ctx.moveTo(layout.t2screen(event.previous.time),layout.$2screen(event.previous.value));ctx.lineTo(x,y);ctx.stroke();
        ctx.fillText(event.kind==='bullish'?'Bull':'Bear',x+3,y+(event.kind==='bullish'?14:-8));
    }
    ctx.restore();
}
